/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/interfaces"/>
import { IInvoiceRejectionReasonItem } from "../rejectionManagementWizard/interfaces";

export enum ReasonCodeOperationType {
    Delete,
    Invalidate,
    InvalidateAndEdit,
    PutOnHold
}

export interface ReasonCodeOperationDto {
    documentId: number;
    invoiceRejectionReasonItems: IInvoiceRejectionReasonItem[];
    operation: string,
    task: string,
    documentType: string,
}

//Needs to be in sync with back-end EntityType from MediusSuite\Modules\APAutomation\MediusSuite.APAutomation.Domain.Common\RejectionManagement\Enums\EntityType.cs
export enum EntityType {
    SupplierInvoice = "SupplierInvoice",
    EdiDocumentImport = "EdiDocumentImport",
    CaptureDocument = "CaptureDocument"
}